export default [
  {
    name: 'dashboard.index',
    meta: {
      title: 'Dashboard',
      sort: 0,
      authenticatable: true,
      icon: 'dashboard',
    },
  },
  {
    name: 'divider:dashboard/index',
    meta: {
      sort: 1,
      divider: true,
      height: 2,
    }
  }
]
